import { ListTituloService } from 'application/services/list-titulos'
import { api } from 'infra/adapters/http-client-adapter'

export const handleListTitulo = new ListTituloService(api)
